import { useT } from '@/lib/i18n/translate'
import { forgotPasswordPathFor } from '@/lib/return-path'

/**
 * The E4 first-login story (2026-09-02): no temporary password, no welcome
 * email — the person proves the inbox via forgot-password and picks their own.
 * Also, the recovery for a lost password, so the detail page shows it too.
 */
export function FirstLoginHint({ email }: { email: string }) {
  const t = useT()
  const url = `${window.location.origin}${forgotPasswordPathFor('platform')}`
  return (
    <div className="flex flex-col gap-2 text-sm">
      <p>{t('users.firstLoginIntro', { email })}</p>
      <a href={url} className="text-accent-ink font-medium break-all hover:underline">
        {url}
      </a>
    </div>
  )
}
